import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { PerformanceChart } from '../components/performance-chart';

export const PerformanceChartProvider = ({ store, data }) => (
    <Provider store={store}>
        <PerformanceChart {...data} />
    </Provider>
);

PerformanceChartProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
